import { FC } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { WrapDrawerEditForm } from '../index'
import RpLimitFormBase from './base'
import { useRpLimitForm } from './useRpLimitForm'
import { Prp2boxApiLimit } from '../../prp2boxApi'
import { CreateRpLimitPayload } from '../../prp2boxApi/limits'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { TRpLimitFormData } from './schema'

type TRpLimitFormEditProps = {
  limitId: string
}

const RpLimitFormEdit: FC<TRpLimitFormEditProps> = (props) => {
  const { limitId } = props
  const queryClient = useQueryClient()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useRpLimitForm()

  const { data: limit } = useQuery(
    [`get rp limit ${limitId}`],
    async () => {
      return Prp2boxApiLimit.getLimitById({ id: Number(limitId) })
    },
    {
      onSuccess: (data) => {
        reset({
          name: data.name ?? '',
          min: data.min ?? 1,
          max: data.max ?? undefined,
          maxPayout: data.maxPayout ?? undefined,
        })
      },
      refetchOnWindowFocus: false,
    }
  )

  const updateLimitMutation = useMutation(
    (updLimit: CreateRpLimitPayload) => Prp2boxApiLimit.update(Number(limitId), updLimit),
    {
      onSuccess: () => {
        toast.success('Лимит успешно обновлен')

        queryClient.invalidateQueries([EQueryKeysConstant.RP_LIMITS])
      },
    }
  )

  const handleSave = (data: TRpLimitFormData) => {
    const { max = null, maxPayout = null, ...rest } = data

    updateLimitMutation.mutate({
      ...rest,
      max,
      maxPayout,
    })
  }

  return (
    <WrapDrawerEditForm
      title={`Редактирование лимита ${limit?.name}`}
      busyText=""
      isBusy={false}
      onSave={handleSubmit(handleSave)}
      isShowSaveBtn
      isShowEditBtn={false}
      isShowDeleteBtn={false}
      isShowBlockBtn={false}>
      <RpLimitFormBase register={register} errors={errors} />
    </WrapDrawerEditForm>
  )
}

export default RpLimitFormEdit
